import Axios from 'axios'
import JSON5 from 'json5'
import _ from 'lodash'
import {
  Message
} from 'element-ui'

Axios.defaults.timeout = 5000;
Axios.defaults.baseURL = `${process.env.VUE_APP_BASEURL}api`


// 对请求参数做处理
Axios.interceptors.request.use(
  async config => {
    // config.data 去除没有意义的项并且序列化
    config.data = JSON.stringify(_.isObject(config.data) ? _.omitBy(_.omitBy(config.data, _.isNull), _.isUndefined) : config.data);
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 响应拦截器即异常处理
Axios.interceptors.response.use(response => {
  if (response.headers['content-type'] === 'application/json') {
    response.data = typeof response.data === 'string' ? JSON5.parse(response.data) : response.data;
    if (response && !response.data.code) {
      return response;
    }
    Message.error(response.data.desc);
    return Promise.reject(response);
  }
  return response
}, err => {
  if (err && err.response) {
    const errMes = err.response.data.desc;
    switch (err.response.status) {
      case 400:
        Message.error(errMes || '错误请求');
        break;
      case 401:
        Message.error(errMes || '用户未登录');
        break;
      case 403:
        Message.error(errMes || '拒绝访问');
        break;
      case 404:
        Message.error(errMes || '请求错误,未找到该资源');
        break;
      case 405:
        Message.error(errMes || '请求方法未允许');
        break;
      case 406:
        Message.error(errMes || '请求方法不被接受');
        break;
      case 408:
        Message.error(errMes || '请求超时');
        break;
      case 500:
        Message.error(errMes || '服务器端出错');
        break;
      case 501:
        Message.error(errMes || '网络未实现');
        break;
      case 502:
        Message.error(errMes || '网络错误');
        break;
      case 503:
        Message.error(errMes || '服务不可用');
        break;
      case 504:
        Message.error(errMes || '网络超时');
        break;
      case 505:
        Message.error(errMes || 'http版本不支持该请求');
        break;
      default:
        Message.error(errMes || `连接错误${err.response.status}`);
        break;
    }
    return Promise.reject(err)
  }
  return Promise.reject(err)
});

/**
 * 封装get方法
 * @param {string} url - 接口地址
 * @param {object} params = {} - 接口参数
 * @returns {*} Promise
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      params: params
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装delete方法
 * @param {string} url - 接口地址
 * @param {object} params = {} - 接口参数
 * @returns {*} Promise
 */

export function del (url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios.delete(url, {
      params: params
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param {string} url - 接口地址
 * @param {object} data = {} - 接口参数
 * @returns {*} Promise
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.post(url, data)
      .then(response => {
        resolve(response.data.data)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param {string} url - 接口地址
 * @param {object} data = {} - 接口参数
 * @returns {*} Promise
 */

export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.patch(url, data)
      .then(response => {
        resolve(response.data.data)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param {string} url - 接口地址
 * @param {object} data = {} - 接口参数
 * @returns {*} Promise
 */

export function put (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.put(url, data)
      .then(response => {
        resolve(response.data.data)
      }, err => {
        reject(err)
      })
  })
}
